// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OauthResultRouteImport } from './routes/oauth-result'
import { Route as userRouteRouteImport } from './routes/(user)/route'
import { Route as LocaleRouteRouteImport } from './routes/$locale/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as userOnboardingRouteImport } from './routes/(user)/onboarding'
import { Route as userMyprofilesRouteImport } from './routes/(user)/myprofiles'
import { Route as userAdminRouteRouteImport } from './routes/(user)/admin/route'
import { Route as usertenantRouteRouteImport } from './routes/(user)/(tenant)/route'
import { Route as LocaleIndexRouteImport } from './routes/$locale/index'
import { Route as LocaleContactRouteImport } from './routes/$locale/contact'
import { Route as LocaleAuthRouteRouteImport } from './routes/$locale/auth/route'
import { Route as userRAssignmentIdRouteImport } from './routes/(user)/r.$assignmentId'
import { Route as userMyprofilesAssignmentIdRouteImport } from './routes/(user)/myprofiles_.$assignmentId'
import { Route as userTTenantSlugRouteRouteImport } from './routes/(user)/t.$tenantSlug/route'
import { Route as userAdminIndexRouteImport } from './routes/(user)/admin/index'
import { Route as userAdminTenantsRouteImport } from './routes/(user)/admin/tenants'
import { Route as userAdminSubmissionsRouteImport } from './routes/(user)/admin/submissions'
import { Route as usertenantEvaluationsRouteImport } from './routes/(user)/(tenant)/evaluations'
import { Route as usertenantDashboardRouteImport } from './routes/(user)/(tenant)/dashboard'
import { Route as usertenantBriefsRouteImport } from './routes/(user)/(tenant)/briefs'
import { Route as usertenantAssignmentsRouteImport } from './routes/(user)/(tenant)/assignments'
import { Route as usertenantAccountRouteImport } from './routes/(user)/(tenant)/account'
import { Route as LocaleLegalSlugRouteImport } from './routes/$locale/legal.$slug'
import { Route as LocaleAuthIndexRouteImport } from './routes/$locale/auth/index'
import { Route as LocaleAuthLinkRouteImport } from './routes/$locale/auth/link'
import { Route as userTTenantSlugSettingsRouteImport } from './routes/(user)/t.$tenantSlug/settings'
import { Route as userTTenantSlugEvaluationsRouteImport } from './routes/(user)/t.$tenantSlug/evaluations'
import { Route as userTTenantSlugDashboardRouteImport } from './routes/(user)/t.$tenantSlug/dashboard'
import { Route as userTTenantSlugBriefsRouteImport } from './routes/(user)/t.$tenantSlug/briefs'
import { Route as userTTenantSlugBillingRouteImport } from './routes/(user)/t.$tenantSlug/billing'
import { Route as userTTenantSlugAssignmentsRouteImport } from './routes/(user)/t.$tenantSlug/assignments'
import { Route as userTTenantSlugAccountRouteImport } from './routes/(user)/t.$tenantSlug/account'
import { Route as userAdminSubmissionsAssignmentIdRouteImport } from './routes/(user)/admin/submissions_.$assignmentId'
import { Route as LocaleAuthVerifyRequestRouteImport } from './routes/$locale/auth/verify/request'
import { Route as LocaleAuthVerifyApplyRouteImport } from './routes/$locale/auth/verify/apply'
import { Route as userTTenantSlugEvaluationsAssignmentIdRouteImport } from './routes/(user)/t.$tenantSlug/evaluations_.$assignmentId'
import { Route as userTTenantSlugBriefsBriefIdRouteImport } from './routes/(user)/t.$tenantSlug/briefs_.$briefId'

const OauthResultRoute = OauthResultRouteImport.update({
            id: '/oauth-result',path: '/oauth-result',getParentRoute: () => rootRouteImport
          })
const userRouteRoute = userRouteRouteImport.update({
            id: '/(user)',getParentRoute: () => rootRouteImport
          })
const LocaleRouteRoute = LocaleRouteRouteImport.update({
            id: '/$locale',path: '/$locale',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const userOnboardingRoute = userOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => userRouteRoute
          })
const userMyprofilesRoute = userMyprofilesRouteImport.update({
            id: '/myprofiles',path: '/myprofiles',getParentRoute: () => userRouteRoute
          })
const userAdminRouteRoute = userAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => userRouteRoute
          })
const usertenantRouteRoute = usertenantRouteRouteImport.update({
            id: '/(tenant)',getParentRoute: () => userRouteRoute
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleRouteRoute
          })
const LocaleContactRoute = LocaleContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => LocaleRouteRoute
          })
const LocaleAuthRouteRoute = LocaleAuthRouteRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => LocaleRouteRoute
          })
const userRAssignmentIdRoute = userRAssignmentIdRouteImport.update({
            id: '/r/$assignmentId',path: '/r/$assignmentId',getParentRoute: () => userRouteRoute
          })
const userMyprofilesAssignmentIdRoute = userMyprofilesAssignmentIdRouteImport.update({
            id: '/myprofiles_/$assignmentId',path: '/myprofiles/$assignmentId',getParentRoute: () => userRouteRoute
          })
const userTTenantSlugRouteRoute = userTTenantSlugRouteRouteImport.update({
            id: '/t/$tenantSlug',path: '/t/$tenantSlug',getParentRoute: () => userRouteRoute
          })
const userAdminIndexRoute = userAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => userAdminRouteRoute
          })
const userAdminTenantsRoute = userAdminTenantsRouteImport.update({
            id: '/tenants',path: '/tenants',getParentRoute: () => userAdminRouteRoute
          })
const userAdminSubmissionsRoute = userAdminSubmissionsRouteImport.update({
            id: '/submissions',path: '/submissions',getParentRoute: () => userAdminRouteRoute
          })
const usertenantEvaluationsRoute = usertenantEvaluationsRouteImport.update({
            id: '/evaluations',path: '/evaluations',getParentRoute: () => usertenantRouteRoute
          })
const usertenantDashboardRoute = usertenantDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => usertenantRouteRoute
          })
const usertenantBriefsRoute = usertenantBriefsRouteImport.update({
            id: '/briefs',path: '/briefs',getParentRoute: () => usertenantRouteRoute
          })
const usertenantAssignmentsRoute = usertenantAssignmentsRouteImport.update({
            id: '/assignments',path: '/assignments',getParentRoute: () => usertenantRouteRoute
          })
const usertenantAccountRoute = usertenantAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => usertenantRouteRoute
          })
const LocaleLegalSlugRoute = LocaleLegalSlugRouteImport.update({
            id: '/legal/$slug',path: '/legal/$slug',getParentRoute: () => LocaleRouteRoute
          })
const LocaleAuthIndexRoute = LocaleAuthIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleAuthRouteRoute
          })
const LocaleAuthLinkRoute = LocaleAuthLinkRouteImport.update({
            id: '/link',path: '/link',getParentRoute: () => LocaleAuthRouteRoute
          })
const userTTenantSlugSettingsRoute = userTTenantSlugSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugEvaluationsRoute = userTTenantSlugEvaluationsRouteImport.update({
            id: '/evaluations',path: '/evaluations',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugDashboardRoute = userTTenantSlugDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugBriefsRoute = userTTenantSlugBriefsRouteImport.update({
            id: '/briefs',path: '/briefs',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugBillingRoute = userTTenantSlugBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugAssignmentsRoute = userTTenantSlugAssignmentsRouteImport.update({
            id: '/assignments',path: '/assignments',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugAccountRoute = userTTenantSlugAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userAdminSubmissionsAssignmentIdRoute = userAdminSubmissionsAssignmentIdRouteImport.update({
            id: '/submissions_/$assignmentId',path: '/submissions/$assignmentId',getParentRoute: () => userAdminRouteRoute
          })
const LocaleAuthVerifyRequestRoute = LocaleAuthVerifyRequestRouteImport.update({
            id: '/verify/request',path: '/verify/request',getParentRoute: () => LocaleAuthRouteRoute
          })
const LocaleAuthVerifyApplyRoute = LocaleAuthVerifyApplyRouteImport.update({
            id: '/verify/apply',path: '/verify/apply',getParentRoute: () => LocaleAuthRouteRoute
          })
const userTTenantSlugEvaluationsAssignmentIdRoute = userTTenantSlugEvaluationsAssignmentIdRouteImport.update({
            id: '/evaluations_/$assignmentId',path: '/evaluations/$assignmentId',getParentRoute: () => userTTenantSlugRouteRoute
          })
const userTTenantSlugBriefsBriefIdRoute = userTTenantSlugBriefsBriefIdRouteImport.update({
            id: '/briefs_/$briefId',path: '/briefs/$briefId',getParentRoute: () => userTTenantSlugRouteRoute
          })





const LocaleAuthRouteRouteChildren = {
  LocaleAuthLinkRoute: LocaleAuthLinkRoute,LocaleAuthIndexRoute: LocaleAuthIndexRoute,LocaleAuthVerifyApplyRoute: LocaleAuthVerifyApplyRoute,LocaleAuthVerifyRequestRoute: LocaleAuthVerifyRequestRoute
}

const LocaleAuthRouteRouteWithChildren = LocaleAuthRouteRoute._addFileChildren(LocaleAuthRouteRouteChildren)



const LocaleRouteRouteChildren = {
  LocaleAuthRouteRoute: LocaleAuthRouteRouteWithChildren,LocaleContactRoute: LocaleContactRoute,LocaleIndexRoute: LocaleIndexRoute,LocaleLegalSlugRoute: LocaleLegalSlugRoute
}

const LocaleRouteRouteWithChildren = LocaleRouteRoute._addFileChildren(LocaleRouteRouteChildren)




const usertenantRouteRouteChildren = {
  usertenantAccountRoute: usertenantAccountRoute,usertenantAssignmentsRoute: usertenantAssignmentsRoute,usertenantBriefsRoute: usertenantBriefsRoute,usertenantDashboardRoute: usertenantDashboardRoute,usertenantEvaluationsRoute: usertenantEvaluationsRoute
}

const usertenantRouteRouteWithChildren = usertenantRouteRoute._addFileChildren(usertenantRouteRouteChildren)




const userAdminRouteRouteChildren = {
  userAdminSubmissionsRoute: userAdminSubmissionsRoute,userAdminTenantsRoute: userAdminTenantsRoute,userAdminIndexRoute: userAdminIndexRoute,userAdminSubmissionsAssignmentIdRoute: userAdminSubmissionsAssignmentIdRoute
}

const userAdminRouteRouteWithChildren = userAdminRouteRoute._addFileChildren(userAdminRouteRouteChildren)




const userTTenantSlugRouteRouteChildren = {
  userTTenantSlugAccountRoute: userTTenantSlugAccountRoute,userTTenantSlugAssignmentsRoute: userTTenantSlugAssignmentsRoute,userTTenantSlugBillingRoute: userTTenantSlugBillingRoute,userTTenantSlugBriefsRoute: userTTenantSlugBriefsRoute,userTTenantSlugDashboardRoute: userTTenantSlugDashboardRoute,userTTenantSlugEvaluationsRoute: userTTenantSlugEvaluationsRoute,userTTenantSlugSettingsRoute: userTTenantSlugSettingsRoute,userTTenantSlugBriefsBriefIdRoute: userTTenantSlugBriefsBriefIdRoute,userTTenantSlugEvaluationsAssignmentIdRoute: userTTenantSlugEvaluationsAssignmentIdRoute
}

const userTTenantSlugRouteRouteWithChildren = userTTenantSlugRouteRoute._addFileChildren(userTTenantSlugRouteRouteChildren)



const userRouteRouteChildren = {
  usertenantRouteRoute: usertenantRouteRouteWithChildren,userAdminRouteRoute: userAdminRouteRouteWithChildren,userMyprofilesRoute: userMyprofilesRoute,userOnboardingRoute: userOnboardingRoute,userTTenantSlugRouteRoute: userTTenantSlugRouteRouteWithChildren,userMyprofilesAssignmentIdRoute: userMyprofilesAssignmentIdRoute,userRAssignmentIdRoute: userRAssignmentIdRoute
}

const userRouteRouteWithChildren = userRouteRoute._addFileChildren(userRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LocaleRouteRoute: LocaleRouteRouteWithChildren,userRouteRoute: userRouteRouteWithChildren,OauthResultRoute: OauthResultRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)